import React, {useContext, useEffect, useRef, useState} from 'react';
import './Messages.css'
import send from '../../accets/img/send.png'
import task_img from '../../accets/img/task.png'
import check from '../../accets/img/check.png'
import double_check from '../../accets/img/double_check.png'
import {FriendContext, SocketContext} from "../../App";
import {fetchUsers} from "../../http/UserAPI";
import {Context} from "../../index";
import {createMsg} from "../../http/ChatAPI";
import {useNavigate} from "react-router-dom";

const Messages = () => {

    const {messages, oneFriend, oneChatId, setOneFriend} = useContext(FriendContext)
    const {userStore} = useContext(Context)
    const {socket} = useContext(SocketContext)

    const navigate = useNavigate()

    const [allUsers, setAllUsers] = useState([])
    const [msgText, setMsgText] = useState('')
    const bottomDiv = useRef(null)

    useEffect(() => {
        fetchUsers().then(data => setAllUsers(data))
    }, [])

    useEffect(() => {
        bottomDiv.current?.scrollIntoView()
    })


    const noReadMsgChat = messages.filter(i => i.firstSocketId === oneFriend && i.secondSocketId === userStore.user.socketId && i.isRead === false)

    useEffect(() => {
        if (noReadMsgChat !== 0) {
            noReadMsgChat.forEach((msg) => {
                socket.emit("isReadReq", {
                    id: msg.id,
                    firstSocketId: msg.firstSocketId,
                    secondSocketId: msg.secondSocketId,
                    message: msg.message,
                    chatId: msg.chatId,
                    createdAt: msg.createdAt
                })

            })

        }
    }, [noReadMsgChat])


    const sendMessage = () => {
        createMsg(userStore.user.socketId, oneFriend, msgText, oneChatId)
        setMsgText('')
    }

    let date = new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
    })

    const onEnterPress = (e) => {
        if (msgText) {
            if (e.keyCode === 13 && e.shiftKey === false) {
                e.preventDefault();
                sendMessage()
            }
        }

    }
    const urlRegex = /(https?:\/\/[^\s]+)/gm;
    const urlTasks = /(task)/;

    const UserToOneFriend = allUsers.filter(usr => usr.socketId === oneFriend)

    return (
        <>
            {oneFriend.length === undefined
                ?
                <div className="no__msg">
                    <div className="no__msg__title">Выберите пользователя для отправки сообщения или добавьте новый
                        чат
                    </div>
                </div>
                :
                <div className="msg__all__block" style={{display: oneFriend.length === undefined ? "none" : "block"}}>
                    <div className="cls__msg__mobile__block" onClick={() => setOneFriend({})}></div>
                    {UserToOneFriend.map(i =>
                        <div key={i.id}
                             className="msg__name__title__block">{i.firstName} {i.secondName}</div>
                    )}

                    <div className="chat__msg__block">
                        <div ref={bottomDiv}/>
                        {messages.filter(msg => msg.chatId === oneChatId)
                            .reverse()
                            .sort(({id: previoudID}, {id: currentID}) => currentID - previoudID)
                            .map((message) => {
                                    message.message.split(urlRegex)
                                    message.message.split(urlTasks)
                                    if (message.message.match(urlRegex)) {
                                        return (
                                            <div key={message.id}
                                                 className={message.firstSocketId === oneFriend ? "message__block" : "message__block__your"}>
                                                {UserToOneFriend.map(i => {
                                                        if (message.firstSocketId === oneFriend) {
                                                            return <div key={i.id} className={
                                                                message.firstSocketId === oneFriend ? "msg__name__block" : "msg__name__block__your"
                                                            }>
                                                                <div className="read__check">
                                                                    {message.isRead
                                                                        ? <img src={double_check} alt={double_check}></img>
                                                                        : <img src={check} alt={check}></img>
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="date__msg">{date.format(Date.parse(message.createdAt))}</div>
                                                                <div
                                                                    className=
                                                                        {
                                                                            message.firstSocketId === oneFriend ? "message__name" : "message__name__your"
                                                                        }
                                                                >
                                                                    {
                                                                        message.firstSocketId === oneFriend ? `${i.secondName}` : "Вы"
                                                                    }
                                                                </div>

                                                            </div>
                                                        } else {
                                                            return <div key={i.id} className={
                                                                message.firstSocketId === oneFriend ? "msg__name__block" : "msg__name__block__your"
                                                            }>
                                                                <div
                                                                    className=
                                                                        {
                                                                            message.firstSocketId === oneFriend ? "message__name" : "message__name__your"
                                                                        }
                                                                >
                                                                    {
                                                                        message.firstSocketId === oneFriend ? `${i.secondName}` : "Вы"
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="date__msg">{date.format(Date.parse(message.createdAt))}</div>
                                                                <div className="read__check">
                                                                    {message.isRead
                                                                        ? <img src={double_check} alt={double_check}></img>
                                                                        : <img src={check} alt={check}></img>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                )}
                                                <a href={message.message} target="_blank"
                                                   rel="noopener noreferrer">{message.message}</a>
                                            </div>
                                        )
                                    } else if (message.message.match(urlTasks)) {
                                        return (
                                            <div key={message.id}
                                                 className={message.firstSocketId === oneFriend ? "message__block" : "message__block__your"}>
                                                {UserToOneFriend.map(i => {
                                                        if (message.firstSocketId === oneFriend) {
                                                            return <div key={i.id} className={
                                                                message.firstSocketId === oneFriend ? "msg__name__block" : "msg__name__block__your"
                                                            }>
                                                                <div className="read__check">
                                                                    {message.isRead
                                                                        ? <img src={double_check} alt={double_check}></img>
                                                                        : <img src={check} alt={check}></img>
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="date__msg">{date.format(Date.parse(message.createdAt))}</div>
                                                                <div
                                                                    className=
                                                                        {
                                                                            message.firstSocketId === oneFriend ? "message__name" : "message__name__your"
                                                                        }
                                                                >
                                                                    {
                                                                        message.firstSocketId === oneFriend ? `${i.secondName}` : "Вы"
                                                                    }
                                                                </div>

                                                            </div>
                                                        } else {
                                                            return <div key={i.id} className={
                                                                message.firstSocketId === oneFriend ? "msg__name__block" : "msg__name__block__your"
                                                            }>
                                                                <div
                                                                    className=
                                                                        {
                                                                            message.firstSocketId === oneFriend ? "message__name" : "message__name__your"
                                                                        }
                                                                >
                                                                    {
                                                                        message.firstSocketId === oneFriend ? `${i.secondName}` : "Вы"
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="date__msg">{date.format(Date.parse(message.createdAt))}</div>
                                                                <div className="read__check">
                                                                    {message.isRead
                                                                        ? <img src={double_check} alt={double_check}></img>
                                                                        : <img src={check} alt={check}></img>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                )}
                                                <div className="t__t__m__b"
                                                     onClick={() => navigate(`../${message.message}`)}>
                                                    <div className="t__t__m__img">
                                                        <img src={task_img} alt={task_img}></img>
                                                    </div>
                                                    <div className="t__t__m__num__b">
                                                        <div className="t__t__m__num">Задача
                                                            №{message.message.replace('task/', '')}</div>
                                                        <div className="t__t__m__hr"></div>
                                                        <div>нажмите чтобы перейти к ней</div>
                                                    </div>

                                                </div>

                                            </div>
                                        )

                                    } else {
                                        return (
                                            <div key={message.id}
                                                 className={message.firstSocketId === oneFriend ? "message__block" : "message__block__your"}>
                                                {UserToOneFriend.map(i => {
                                                        if (message.firstSocketId === oneFriend) {
                                                            return <div key={i.id} className={
                                                                message.firstSocketId === oneFriend ? "msg__name__block" : "msg__name__block__your"
                                                            }>
                                                                <div className="read__check">
                                                                    {message.isRead
                                                                        ? <img src={double_check} alt={double_check}></img>
                                                                        : <img src={check} alt={check}></img>
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="date__msg">{date.format(Date.parse(message.createdAt))}</div>
                                                                <div
                                                                    className=
                                                                        {
                                                                            message.firstSocketId === oneFriend ? "message__name" : "message__name__your"
                                                                        }
                                                                >
                                                                    {
                                                                        message.firstSocketId === oneFriend ? `${i.secondName}` : "Вы"
                                                                    }
                                                                </div>

                                                            </div>
                                                        } else {
                                                            return <div key={i.id} className={
                                                                message.firstSocketId === oneFriend ? "msg__name__block" : "msg__name__block__your"
                                                            }>
                                                                <div
                                                                    className=
                                                                        {
                                                                            message.firstSocketId === oneFriend ? "message__name" : "message__name__your"
                                                                        }
                                                                >
                                                                    {
                                                                        message.firstSocketId === oneFriend ? `${i.secondName}` : "Вы"
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="date__msg">{date.format(Date.parse(message.createdAt))}</div>
                                                                <div className="read__check">
                                                                    {message.isRead
                                                                        ? <img src={double_check} alt={double_check}></img>
                                                                        : <img src={check} alt={check}></img>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                )}
                                                <div className="message">{message.message}</div>
                                            </div>
                                        )
                                    }
                                }
                            )}

                    </div>
                    <div className="chat__msg__input">
                <textarea
                    onKeyDown={onEnterPress}
                    value={msgText}
                    onChange={event => setMsgText(event.target.value)}
                    className="msg__input"
                    placeholder="Напишите что-то...">
                </textarea>
                        {!msgText
                            ?
                            <div
                                className="msg__btn__input__no__txt"
                            >
                                <img src={send} alt={send}/>
                            </div>
                            :
                            <div
                                className="msg__btn__input"
                                onClick={() => sendMessage()}
                            >
                                <img src={send} alt={send}/>
                            </div>
                        }

                    </div>
                </div>

            }
        </>
    );
};

export default Messages;